<template src="./HeaderLogo.html"></template>

<script>

export default {
    name: 'HeaderLogo',
}
</script>

<style lang="scss" src="./HeaderLogo.scss"> </style>